/**
 * Date format
 */
export default function datefmt(date = 0, format = "Y-M-D h:m:s") {
    date = new Date(date);

    const Y = date.getFullYear();
    const M = (date.getMonth() + 1).toString().padStart(2, "0");
    const D = date.getDate().toString().padStart(2, "0");
    const h = date.getHours().toString().padStart(2, "0");
    const m = date.getMinutes().toString().padStart(2, "0");
    const s = date.getSeconds().toString().padStart(2, "0");

    return format //
        .replace(/Y/g, Y)
        .replace(/M/g, M)
        .replace(/D/g, D)
        .replace(/h/g, h)
        .replace(/m/g, m)
        .replace(/s/g, s);
}
